import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail, Facebook, Instagram, Twitter } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <footer className="bg-black text-white border-t border-red-900/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_pizzeria-online-10/artifacts/oqe0cyb4_Food_Menu__4_-removebg-preview.png" 
              alt="La Casa Del Pizza" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Pizzas artisanales au feu de bois.
              La passion de la vraie pizza italienne à Marseille.
            </p>
            <div className="flex gap-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-500">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-gray-400 hover:text-white transition-colors">
                  Notre Menu
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToSection('notre-histoire-section')} className="text-gray-400 hover:text-white transition-colors">
                  À Propos
                </button>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-500">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400">
                <Phone size={18} className="mt-1 flex-shrink-0 text-red-500" />
                <div>
                  <a href={`tel:${restaurantInfo.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors">
                    {restaurantInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-red-500" />
                <div>
                  {restaurantInfo.address}
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Mail size={18} className="mt-1 flex-shrink-0 text-red-500" />
                <div>
                  <a href="mailto:seven.pizza13005@gmail.com" className="hover:text-white transition-colors">
                    seven.pizza13005@gmail.com
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-red-500">Horaires</h3>
            <div className="flex items-start gap-3 mb-4">
              <Clock size={18} className="mt-1 flex-shrink-0 text-red-500" />
              <div>
                <p className="text-white font-semibold mb-2">{restaurantInfo.hours.days}</p>
                <p className="text-gray-400 text-sm">Midi: {restaurantInfo.hours.lunch}</p>
                <p className="text-gray-400 text-sm">Soir: {restaurantInfo.hours.dinner}</p>
              </div>
            </div>
            <div className="bg-red-600/20 border border-red-500/50 rounded-lg p-3 mt-4">
              <p className="text-red-400 font-semibold text-sm">
                🚚 {restaurantInfo.delivery}
              </p>
            </div>
          </div>
        </div>

        {/* Delivery Zones */}
        <div className="border-t border-gray-800 pt-6 mb-6">
          <h4 className="text-sm font-semibold text-gray-400 mb-3">Zones de livraison :</h4>
          <div className="flex flex-wrap gap-2">
            {restaurantInfo.deliveryZones.map((zone) => (
              <span 
                key={zone} 
                className="bg-gray-900 text-gray-400 text-xs px-3 py-1 rounded-full border border-gray-800"
              >
                {zone}
              </span>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2024 La Casa Del Pizza. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <Link to="/mentions-legales" className="hover:text-white transition-colors">
              Mentions Légales
            </Link>
            <Link to="/confidentialite" className="hover:text-white transition-colors">
              Politique de Confidentialité
            </Link>
            <Link to="/cgv" className="hover:text-white transition-colors">
              CGV
            </Link>
          </div>
        </div>

        {/* Ticket Restaurant Badge */}
        <div className="flex justify-center mt-6">
          <div className="bg-gray-900 px-6 py-3 rounded-lg border border-gray-800">
            <p className="text-gray-400 text-sm">
              💳 Nous acceptons les <span className="text-white font-semibold">Tickets Restaurant</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
